// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  NAME: 'common.dataView.name',
  DESCRIPTION: 'common.description',
  COLOR: 'common.color',
  PALETTE: 'common.palette',
  GRADIENT: 'common.gradient',
  FONT_DISPLAY: 'common.fontDisplay',
  GRADIENT_REVERSE: 'common.gradient.reverse',
  SYMBOL_SIZE_RANGE: 'common.symbol.size.range',
  IMAGE_SIZE_RANGE: 'common.image.size.range',
  QUERY_EXECUTION_STRATEGY: 'common.query.execution',
  ATTRIBUTE_CLIPBOARD_EXPANDED: 'common.attributeClipboard.expanded',
  SPATIAL_FILTER_MODE: 'common.spatialFilter.mode',
  SELECTION_ENABLED: 'common.selection.enabled',
  SELECTION_ONE_CLICK_FILTERING_ENABLED: 'common.selection.oneClickFiltering.enabled',
  ANALYSIS_CONTEXT_FILTER_ACTIVE: 'analysis.context.filter.active',
  ROW_COUNT_LIMIT: 'common.row.count.limit',
  DISPLAY_DRILL_THROUGH: 'common.drillThrough.display',
  DRILL_THROUGH_DISPLAY_MODE: 'common.drillThrough.display.mode',
  DISPLAY_FILTER_ACTION: 'common.display.filter.action',
  DISPLAY_EXPORT_ACTION: 'common.display.export.action',
  PRECONDITION_NOT_FULFILLED_MESSAGE: 'common.precondition.not.fulfilled.message'
} as const;

/** @see net/disy/cadenza/workbook/model/CommonDataViewSettingsKey.java */
export type CommonDataViewSettingsKey = keyof typeof COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const CommonDataViewSettingsKey = {
  values: Object.keys(COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly CommonDataViewSettingsKey[],
  toPersistenceKey: (value: CommonDataViewSettingsKey) => COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = CommonDataViewSettingsKey.values.find(key => COMMON_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No CommonDataViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
